import React, { useEffect, useState } from "react";
import { Modal, } from "reactstrap";
import { toast } from 'react-toastify';
import stateServices from "../../services/state.services";
import cityServices from "../../services/city.services";
import CenterForm from "../../components/Center/CenterForm";
import CenterList from "../../components/Center/CenterList";
import centerServices from "../../services/center.services";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import userServices from "../../services/user.services";
import CenterUserList from "../../components/Center/CenterUserList";
import CenterUserForm from "../../components/Center/CenterUserForm";
import CenterEditForm from "../../components/Center/CenterEditForm";
const Index = () => {
    const [modal, setModal] = React.useState(false);
    const toggle = () => setModal(!modal);
    const [centers, setCenters] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedRow, setSelectedRow] = useState();
    const [isAddMode, setIsAddMode] = useState('Add');
    const [isCenter, setIsCenter] = useState(true)
    const [users, setUsers] = useState([]);
    const [loadingCenters, setLoadingCenters] = useState(true);
    const [loadingUsers, setLoadingUsers] = useState(true);

    const getAllCenters = () => {
        centerServices.getAllCenter()
            .then((res) => {
                if (res.data.status === true) {
                    setCenters(res.data.centers)
                }
                setLoadingCenters(false);
            }).catch((error) => {
                console.log('error', error)
                setLoadingCenters(false);
            })
    }
    const getAllCenterUsers = async () => {
        const centerUser = await userServices.getAllUsers()
        console.log('centerUser', centerUser)
        const centerUserFilter = centerUser.data.users.filter((item) => {
            return item.user_type_id === 2;
        })
        setUsers(centerUserFilter)
        setLoadingUsers(false);
    }

    const deleteCenterById = async (id) => {
        const result = await centerServices.deleteCenterById({ id: id });
        if (result.data.status === true) {
            toast.success('Record deleted successfully', { toastId: 'userDelete_success', autoClose: 3000 });
            getAllCenters();
        } else {
            toast.error(result.data.message, { toastId: 'userDelete_faild', autoClose: 3000 });
        }
    }
    const handleChangeStatus = async (id, status) => {
        const result = await centerServices.updateCenterById(id, { center_status: status })
        if (result.data.status === true) {
            getAllCenters()
            toast.success('Status updated successfully', { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }

    const deleteUserById = async (id) => {
        const result = await userServices.deleteUserById({ id: id });
        if (result.data.status === true) {
            toast.success(result.data.message, { toastId: 'userDelete_success', autoClose: 3000 });
            getAllCenterUsers();
        } else {
            toast.error(result.data.message, { toastId: 'userDelete_faild', autoClose: 3000 });
        }
    }

    const handleChangeUserStatus = async (id, status) => {
        console.log('status', status);
        const result = await userServices.updateUserById(id, { user_status: status })
        if (result.data.status === true) {
            getAllCenterUsers()
            toast.success('Status updated successfully', { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }

    useEffect(() => {
        getAllCenters();
        stateServices.getAllStates().then((res) => {
            if (res.data.status === true) {
                setStates(res.data.states)
            }
        });
        cityServices.getAllCity().then((res) => {
            if (res.data.status === true) {
                setCities(res.data.cities)
            }
        });
        getAllCenterUsers()
    }, [])
    const filterCenter = centers.map((center) => {
        states.map((state) => {
            if (center.state_id === state.state_id) {
                center.state_name = state.state_name
            }
        })
        cities.map((city) => {
            if (center.city_id === city.city_id) {
                center.city_name = city.city_name
            }
        })
        return center
    })
    const handleSelect = (key) => {
        if (key === "center-info") {
            setIsCenter(true)
        }
        else
            setIsCenter(false)
    }
    const filterCenterUser = users.map((user) => {
        centers.map((center) => {
            if (user.center_id === center._id) {
                user.center_name = center.center_name
            }
        })
        return user
    })
    return (
        <React.Fragment>
            {/*page-wrapper*/}
            <div className="page-wrapper">
                {/*page-content-wrapper*/}
                <div className="page-content-wrapper">
                    <div className="page-content">
                        <>
                            {/*breadcrumb*/}
                            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                                {/* <div className="breadcrumb-title pe-3">Center</div> */}
                                <div className="ps-3">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb mb-0 p-0">
                                            <li className="breadcrumb-item">
                                                <a href="#">
                                                    {/* <i className="bx bx-home-alt" /> */}
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                Center
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                                <div className="ms-auto">
                                    <div className="btn-group">
                                        <button className="btn btn-primary"
                                            onClick={() => {
                                                toggle();
                                                setIsAddMode('Add')
                                            }}><i className="bx bx plus" />{isCenter === true ? "Add Center" : "Add Center User"}</button>
                                        {isCenter === true && <Modal isOpen={modal} toggle={toggle} size="lg">
                                            {isAddMode === "Edit" ? <CenterEditForm toggle={toggle} isAddMode={isAddMode} cities={cities} states={states} getAllCenters={getAllCenters} selectedRow={selectedRow} />
                                                :
                                                <CenterForm toggle={toggle} isAddMode={isAddMode} cities={cities} states={states} getAllCenters={getAllCenters} getAllCenterUsers={getAllCenterUsers} selectedRow={selectedRow} />

                                            }
                                        </Modal>
                                        }
                                        {isCenter === false && <Modal isOpen={modal} toggle={toggle} size="lg">
                                            <CenterUserForm toggle={toggle} isAddMode={isAddMode} getAllCenterUsers={getAllCenterUsers} selectedRow={selectedRow} centers={filterCenter} />
                                        </Modal>
                                        }
                                    </div>
                                </div>
                            </div>
                            {/*end breadcrumb*/}
                            <div className="card">

                                <Tabs
                                    defaultActiveKey="center-info"
                                    id="fill-tab-example"
                                    className="mb-3 h6 tab-title-style border-0"
                                    fill
                                    onSelect={(e) => handleSelect(e)}
                                >
                                    <Tab eventKey="center-info" title="Center Info">
                                        <div className="bg-dark h-25"></div>
                                        <div className="card-body">
                                            <CenterList centers={filterCenter} loading={loadingCenters} setIsAddMode={setIsAddMode} setSelectedRow={setSelectedRow} setModal={setModal} deleteCenterById={deleteCenterById} getAllCenters={getAllCenters} handleChangeStatus={handleChangeStatus} />
                                        </div>
                                    </Tab>
                                    <Tab eventKey="center-login" title="Center User Info">
                                        <div className="card-body">
                                            <CenterUserList centers={filterCenterUser} loading={loadingUsers} setIsAddMode={setIsAddMode} setSelectedRow={setSelectedRow} setModal={setModal} deleteUserById={deleteUserById} handleChangeUserStatus={handleChangeUserStatus} />
                                        </div>
                                    </Tab>
                                </Tabs>

                            </div>

                        </>

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Index;